import { render, staticRenderFns } from "./xsfl.vue?vue&type=template&id=52fff9cd"
import script from "./xsfl.vue?vue&type=script&lang=js"
export * from "./xsfl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports